import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';

const userPool = new CognitoUserPool({
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
});

export function signIn(email, password) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });
    const authDetails = new AuthenticationDetails({ Username: email, Password: password });
    user.authenticateUser(authDetails, {
      onSuccess: (session) => resolve({ status: 'SUCCESS', session }),
      onFailure: reject,
      newPasswordRequired: () =>
        resolve({
          status: 'NEW_PASSWORD_REQUIRED',
          completeChallenge: (newPassword) =>
            new Promise((res, rej) =>
              user.completeNewPasswordChallenge(newPassword, {}, { onSuccess: res, onFailure: rej })
            ),
        }),
    });
  });
}

export function forgotPassword(email) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });
    user.forgotPassword({ onSuccess: resolve, onFailure: reject });
  });
}

export function confirmForgotPassword(email, code, newPassword) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });
    user.confirmPassword(code, newPassword, { onSuccess: resolve, onFailure: reject });
  });
}

export function signOut() {
  const user = userPool.getCurrentUser();
  if (user) user.signOut();
}

export function getSession() {
  return new Promise((resolve, reject) => {
    const user = userPool.getCurrentUser();
    if (!user) return reject(new Error('No authenticated user'));
    user.getSession((err, session) => {
      if (err || !session.isValid()) return reject(err ?? new Error('Session expired'));
      resolve(session);
    });
  });
}

export async function getIdToken() {
  const session = await getSession();
  return session.getIdToken().getJwtToken();
}
